import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file-download",
  "use": "file-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"file-download\"><path d=\"M8 2h1v8.122l1.975-1.975.004-.004c.042-.037.373-.327.703.004.354.353 0 .71 0 .707L8.5 12.036 5.318 8.854s-.354-.353 0-.707c.353-.353.707-.003.707 0L8 10.122V2z\" /><path d=\"M3 13h11v-2l1-1v4H2v-4l1 1v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol